import { useLazyQuery } from "@apollo/client";
import { useCallback } from "react";
import { CHECK_SLUG_AVAILABILITY } from "../gql";

interface CheckSlugAvailabilityVariables {
  slug: string;
}

interface CheckSlugAvailabilityResponse {
  isOrganizationSlugAvailable: boolean;
}

export function useCheckSlugAvailability() {
  const [checkSlugAvailability, { data, loading, error }] = useLazyQuery<
    CheckSlugAvailabilityResponse,
    CheckSlugAvailabilityVariables
  >(CHECK_SLUG_AVAILABILITY, {
    errorPolicy: "all",
    fetchPolicy: "no-cache", // Always check fresh
  });

  const checkSlug = useCallback(
    async (slug: string): Promise<boolean> => {
      if (!slug || slug.trim().length < 3) {
        return false;
      }

      try {
        const result = await checkSlugAvailability({
          variables: { slug: slug.trim() },
        });

        return result.data?.isOrganizationSlugAvailable ?? false;
      } catch (err) {
        console.error("Error checking slug availability:", err);
        return false;
      }
    },
    [checkSlugAvailability],
  );

  return {
    checkSlug,
    isAvailable: data?.isOrganizationSlugAvailable,
    loading,
    error,
  };
}
